export default {
  name: 'Dashboard',
};
